import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'getCurrentCampaign'

export default () => (asyncAction(
  name,
  CampaignsService.getCurrentCampaign
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/getCurrentCampaign.js